import { render, staticRenderFns } from "./sureSubmit.vue?vue&type=template&id=2dfe46ba&scoped=true"
import script from "./sureSubmit.vue?vue&type=script&lang=js"
export * from "./sureSubmit.vue?vue&type=script&lang=js"
import style0 from "./sureSubmit.vue?vue&type=style&index=0&id=2dfe46ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfe46ba",
  null
  
)

export default component.exports